import { catchError, map } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable({ providedIn: 'root' })
export class PartnershipsService {
  path: string = '/api';
  constructor(private apiService: ApiService) { }

  // airlines to distributors
  getPartnerships(partnerId: any) {
    return this.apiService.get(`${this.path}/partnerships?airline_id=${partnerId}`);
  }

  // distributors to airlines
  getPartnershipsByType(partnerId: any, type: string) {
    return this.apiService.get(`${this.path}/partnerships?partner_id=${partnerId}`);
  }

  getPartners() {
    const observableAirlines = this.apiService.get(`${this.path}/airlines`).pipe(catchError(() => of([])));
    const observableDistrbutors = this.apiService.get(`${this.path}/distributors`).pipe(catchError(() => of([])));
    const observablePlatforms = this.apiService.get(`${this.path}/platforms`).pipe(catchError(() => of([])));
    return forkJoin([observableAirlines, observableDistrbutors, observablePlatforms]).pipe(
      map((response: any) => {
        return response[0].concat(response[1], response[2]);
      }),
    );
  }

  setPartnershipSharing(id: any, isEnabled: boolean) {
    return this.apiService
      .put(`${this.path}/partnerships/${id}`, {
        enabled: isEnabled,
      });
  }

}
